import navigateToCell from './navigate/epic';

export default navigateToCell;
